























































































































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {TextHelper} from '@/helpers/TextHelper'
import {OrbitClaimBarItem} from '@/components/orbit/OrbitClaimBar.vue'

@Component({
  computed: {
    TextHelper() {
      return TextHelper
    },
  },
})
export default class OrbitClaimFormStep extends Vue {
  @Prop({type: Array, required: true}) items!: OrbitClaimBarItem[]

  handleClaim() {
    this.$emit('claim')
  }

  closeModal() {
    this.$emit('close')
  }
}
